module.exports = __webpack_public_path__ + "eb3bb96a8f21d1e62809809daf86c502.svg";